const state = {
    session : JSON.parse(sessionStorage.getItem('session')),
    user: JSON.parse(sessionStorage.getItem('user'))
}

//getter
const getters = {
    getUser : state => {
        return state.user;
    },
    getSession : state => {
        return state.session
    }
}


//mutations
const mutations = {
    setUser (state,user){
        sessionStorage.setItem('user',JSON.stringify(user));
        state.user = user;
    },
    setSession (state,session){
        sessionStorage.setItem('session',JSON.stringify(session));
        state.session = session;
    },
    clearSysteminfo(state){
        sessionStorage.clear();
        state.user = null;
        state.session = null;
    }
}

//actions
const actions = {
    setSystemInfo({ state, commit}, systemInfo){
        if(systemInfo && systemInfo.id){
            commit('setUser',{id: systemInfo.id,username: systemInfo.account,name:systemInfo.name})
        }
        if(systemInfo && systemInfo.session){
            commit('setSession',systemInfo.session)
        }
        //如果信息为空则清空sessionStorage
        if(!systemInfo){

        }
        
    }

}

export default {
    state,
    getters,
    actions,
    mutations
}
  


// WEBPACK FOOTER //
// ./src/store/modules/system.js